export const PLAYER_GRID_STORAGE_KEY = "skyview.player.playersPerRow";
export const DEFAULT_PLAYERS_PER_ROW = 2;
export const MAX_PLAYERS_PER_ROW = 64;

export const parsePlayersPerRow = (value: unknown): number | null => {
  if (typeof value !== "number" && typeof value !== "string") return null;
  if (typeof value === "string" && !value.trim()) return null;
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed >= 1 && parsed <= MAX_PLAYERS_PER_ROW ? parsed : null;
};

export const readPlayersPerRow = (): number => {
  try {
    return parsePlayersPerRow(window.localStorage.getItem(PLAYER_GRID_STORAGE_KEY)) ?? DEFAULT_PLAYERS_PER_ROW;
  } catch {
    return DEFAULT_PLAYERS_PER_ROW;
  }
};

export const persistPlayersPerRow = (value: number): void => {
  try {
    window.localStorage.setItem(PLAYER_GRID_STORAGE_KEY, String(value));
  } catch {
    // Playback and layout controls remain usable when browser storage is unavailable.
  }
};

export const getPlayerGrid = (count: number, playersPerRow: number) => {
  const columns = Math.min(Math.max(1, count), parsePlayersPerRow(playersPerRow) ?? DEFAULT_PLAYERS_PER_ROW);
  return { columns, rows: Math.max(1, Math.ceil(count / columns)) };
};
